import * as React from 'react';
import Icons from '../icons';

export default class Emptyfiles extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptyfile" className="" />    
                <h2>No files found</h2>
                {
                    this.props.type
                    && 
                    <p>Attachments related to the {this.props.type} would be available here.</p>
                }
            </div>
        );
    }
}